module.exports = __webpack_public_path__ + "media/images/area/feature/hokkaido/related/en_6-424fa52447abec3fc05e52442a2c4423.jpg";